// extracted by mini-css-extract-plugin
module.exports = {"brunoDecription":"SciencnewVideo_brunoDecription__t0bEY","PhytoVideoTag":"SciencnewVideo_PhytoVideoTag__mVaYL","PhytoVideoTag1":"SciencnewVideo_PhytoVideoTag1__czZst"};